import { Alert, Platform } from 'react-native';

type ConfirmOptions = {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
};

export function alertMessage(title: string, message?: string) {
  const text = message ? `${title}\n\n${message}` : title;
  if (Platform.OS === 'web') {
    if (typeof globalThis.alert === 'function') {
      globalThis.alert(text);
    }
    return;
  }
  Alert.alert(title, message);
}

export function confirmAction(options: ConfirmOptions): Promise<boolean> {
  if (Platform.OS === 'web') {
    const text = `${options.title}\n\n${options.message}`;
    if (typeof globalThis.confirm === 'function') {
      return Promise.resolve(globalThis.confirm(text));
    }
    return Promise.resolve(false);
  }

  return new Promise(resolve => {
    Alert.alert(options.title, options.message, [
      { text: options.cancelLabel, style: 'cancel', onPress: () => resolve(false) },
      { text: options.confirmLabel, style: 'destructive', onPress: () => resolve(true) },
    ]);
  });
}
